/* tia-buy-sheet.js: the phone size sheet and the size-selection event (growth plan C2, 2026-10-23).

   WHAT IT IS. On a phone, with no size chosen, tapping the fixed Add to Cart bar used to scroll a screen
   and a half to the size row (assets/tia-buy-box.js askForSize). It now calls tiaBuySheet.open(), which
   turns the buy box's own <form class="tia-buy__form" data-tia-sheet="true"> into a bottom sheet: a CSS
   class (.is-sheet), a backdrop and focus handling. There is NO second selector: the radios, the cascade,
   the per-size price, the hidden variant id and the gallery sync are tia-buy-box.js, untouched, so the
   sheet cannot drift from the page. This file never resolves a variant.

   SHEET CONTRACT. No size pre-selected (owner 2026-09-17). Visible close control, Escape, swipe down and
   backdrop tap close it. Focus moves in, is trapped, and returns to the opener. The body is locked while
   open (position:fixed with the scroll offset restored on close, the form that works on iOS Safari).
   The sheet's one Add to Cart is a submit button of the same form; it is disabled until a size is chosen.

   EVENT. When a SIZE radio is chosen, on the page or in the sheet, one GA4 event is sent through the
   page's own gtag (loaded by the Google & YouTube channel): select_item_variant with layout, finish,
   size, value, currency, variant_id and surface ("sheet" or "page"). Served on every viewport so the
   desktop size choice is the baseline for the phone one. */
(function () {
  'use strict';
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 798px)') : { matches: false };
  var api = { open: function () { return false; }, close: function () {} };
  window.tiaBuySheet = api;

  function ga(name, params) {
    try {
      var dl = window.dataLayer || [], id = null, i;
      for (i = 0; i < dl.length; i++) {
        if (dl[i] && dl[i][0] === 'config' && /^G-/.test(dl[i][1])) { id = dl[i][1]; break; }
      }
      if (id) params.send_to = id;           // the GA4 stream only, not the Ads destinations
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); return; }
      window.dataLayer = window.dataLayer || [];
      (function () { window.dataLayer.push(arguments); })('event', name, params);
    } catch (e) { /* analytics must never break the buy flow */ }
  }

  function init() {
    var root = document.querySelector('[data-tia-buy]');
    if (!root || root.getAttribute('data-tia-sheet-init') === '1') return;
    var form = root.querySelector('.tia-buy__form[data-tia-sheet="true"]');
    if (!form) return;
    root.setAttribute('data-tia-sheet-init', '1');

    var backdrop = root.querySelector('[data-tia-sheet-backdrop]');
    var closeBtn = form.querySelector('[data-tia-sheet-close]');
    var sheetAtc = form.querySelector('[data-tia-sheet-atc]');
    var atcLabel = form.querySelector('[data-tia-sheet-atc-label]');
    var outPrice = form.querySelector('[data-tia-sheet-price]');
    var outFrom = form.querySelector('[data-tia-sheet-from]');
    var idInput = form.querySelector('[data-tia-id]');
    var titleId = (form.querySelector('.tia-sheet__title') || {}).id;
    var isOpen = false, opener = null, spacer = null, scrollY = 0, shiftTab = false;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function band(sel) { return document.querySelector('[data-tia-band] ' + sel); }

    /* Mirror the band, which tia-buy-box.js keeps true: the price, the FROM prefix while the size is open,
       and whether the button can be pressed. Read, never recomputed. */
    function sync() {
      var bandAtc = band('[data-tia-atc]');
      var open = !!(bandAtc && bandAtc.hasAttribute('data-tia-open'));
      var price = band('[data-tia-price]');
      if (outPrice && price) outPrice.textContent = price.textContent;
      if (outFrom) outFrom.hidden = !open;
      if (!sheetAtc || !atcLabel) return;
      if (open) { sheetAtc.disabled = true; atcLabel.textContent = 'Choose a size'; return; }
      sheetAtc.disabled = !!(bandAtc && bandAtc.disabled);
      var add = band('[data-tia-atc-text]');
      atcLabel.textContent = sheetAtc.disabled ? 'Sold out' : ((add && add.getAttribute('data-label-add')) || 'Add to Cart');
    }

    function tabbables() {
      var out = [], seen = {};
      Array.prototype.forEach.call(form.querySelectorAll('button, input[type="radio"]'), function (el) {
        if (el.disabled) return;
        if (el.type === 'radio') {
          var lab = el.nextElementSibling;
          if (!lab || !lab.getClientRects().length || seen[el.name]) return;
          seen[el.name] = true;
          var chk = form.querySelector('input[type="radio"][name="' + el.name + '"]:checked');
          out.push(chk || el);
        } else if (el.getClientRects().length) { out.push(el); }
      });
      return out;
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      shiftTab = e.shiftKey;
      var t = tabbables();
      if (!t.length) return;
      if (!e.shiftKey && document.activeElement === t[t.length - 1]) { e.preventDefault(); t[0].focus(); }
      else if (e.shiftKey && document.activeElement === t[0]) { e.preventDefault(); t[t.length - 1].focus(); }
    }
    function onFocusIn(e) {
      if (!isOpen || form.contains(e.target)) return;
      var t = tabbables();
      if (t.length) (shiftTab ? t[t.length - 1] : t[0]).focus({ preventScroll: true });
    }

    function open() {
      if (isOpen) return true;
      if (!MQ.matches) return false;
      var bandAtc = band('[data-tia-atc]');
      opener = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : bandAtc;
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      spacer = document.createElement('div');           // holds the form's place so the page does not jump behind the scrim
      spacer.style.height = form.offsetHeight + 'px';
      spacer.setAttribute('aria-hidden', 'true');
      form.parentNode.insertBefore(spacer, form);
      document.body.style.top = (-scrollY) + 'px';
      document.body.classList.add('tia-sheet-lock');
      if (backdrop) backdrop.hidden = false;
      form.classList.remove('is-closing', 'is-snapback');
      form.classList.add('is-sheet');
      form.setAttribute('role', 'dialog');
      form.setAttribute('aria-modal', 'true');
      if (titleId) form.setAttribute('aria-labelledby', titleId);
      isOpen = true;
      sync();
      document.addEventListener('keydown', onKey, true);
      document.addEventListener('focusin', onFocusIn, true);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
      return true;
    }

    function finish() {
      form.classList.remove('is-sheet', 'is-closing', 'is-snapback');
      form.style.transform = '';
      form.style.transition = '';
      form.removeAttribute('role');
      form.removeAttribute('aria-modal');
      form.removeAttribute('aria-labelledby');
      if (backdrop) backdrop.hidden = true;
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      spacer = null;
      document.body.classList.remove('tia-sheet-lock');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('focusin', onFocusIn, true);
      if (reduced && reduced.matches) { finish(); return; }
      form.classList.add('is-closing');
      var done = false, t;
      var end = function (e) {
        if (e && e.target !== form) return;
        if (done) return; done = true;
        clearTimeout(t); form.removeEventListener('animationend', end); finish();
      };
      form.addEventListener('animationend', end);
      t = setTimeout(end, 320);
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    if (MQ.addEventListener) MQ.addEventListener('change', function () { if (!MQ.matches && isOpen) close(); });

    /* swipe down: from the header, or from anywhere once the sheet is scrolled to its top */
    var startY = null, dy = 0, dragging = false, atTop = false;
    form.addEventListener('touchstart', function (e) {
      if (!isOpen || e.touches.length !== 1) { startY = null; return; }
      startY = e.touches[0].clientY; dy = 0; dragging = false; atTop = form.scrollTop <= 0;
    }, { passive: true });
    form.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      var d = e.touches[0].clientY - startY;
      if (d > 0 && (atTop || dragging)) {
        dragging = true; dy = d; e.preventDefault();
        form.classList.remove('is-snapback');
        form.style.transform = 'translateY(' + d + 'px)';
      }
    }, { passive: false });
    function release() {
      if (startY === null) return;
      startY = null;
      if (!dragging) return;
      dragging = false;
      if (dy > 90) { close(); }
      else { form.classList.add('is-snapback'); form.style.transform = ''; }
    }
    form.addEventListener('touchend', release);
    form.addEventListener('touchcancel', release);

    /* one handler for the sheet's mirror and the analytics: it runs after tia-buy-box.js's own change
       handler (that one is on the fieldset, this is on the form, a later stop in the bubble), so the
       band, the hidden id and the price are already settled when this reads them */
    var variants = [];
    try { variants = JSON.parse((document.querySelector('[data-tia-variants]') || {}).textContent || '[]'); } catch (e) {}
    function checkedOf(g) { var r = g.querySelector('input:checked'); return r ? r.value : null; }
    function onChange(e) {
      if (isOpen) sync();
      var g = e.target && e.target.closest ? e.target.closest('[data-tia-opt]') : null;
      if (!g || !e.target.checked) return;
      var nm = g.getAttribute('data-tia-optname') || '';
      if (nm.indexOf('size') < 0 && nm.indexOf('dimension') < 0) return;
      var params = { surface: isOpen ? 'sheet' : 'page', size: e.target.value };
      Array.prototype.forEach.call(form.querySelectorAll('[data-tia-opt]'), function (og) {
        var on = og.getAttribute('data-tia-optname') || '';
        if (/piece|layout|panel/.test(on)) params.layout = checkedOf(og);
        else if (/frame|finish/.test(on)) params.finish = checkedOf(og);
      });
      var vid = idInput ? idInput.value : '';
      params.variant_id = vid;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(vid)) { params.value = variants[i].p / 100; break; }
      }
      params.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      ga('select_item_variant', params);
    }
    form.addEventListener('change', onChange);

    api.open = open;
    api.close = close;
    api.isOpen = function () { return isOpen; };
  }

  init();
  var prev = window.tiaBuyBoxInit;     // the layout's InstantClick hook re-runs this after a page swap
  window.tiaBuyBoxInit = function () { if (prev) prev(); init(); };
})();
